import { request } from 'shared/lib/request';

export const requestHelpService = (payload) =>
  request.post(`/request-help`, payload);
